<template lang="jade">
  .loaderBackDrop.warning(v-show="showWarning")
    .loader
      .text Screen resolution
      .text must be larger than 1024x768
  .loaderBackDrop(v-if="showLoading")
    .loader
      span.loadStyle.load2
      h2.loadText Searching...
      span.loadTextDetail {{loaderMsg}}
      br
      span.loadTextDetail {{loaderMsg1}}
  .alert_group
    alert.alert__single(
      v-for="(key, a) in alertList"
      v-bind:type="a.type"
      v-bind:show.sync="a.show"
      width="280px"
      dismissable)
      span.icon-ok-circled.alert-icon-float-left
      strong {{ a.title }}
      p {{ a.content }}
  app-header(v-if="$route.path!='/login'" v-bind:show-left-bar.sync="showLeft")
  aside#side_menu(v-bind:show.sync="showLeft" placement="left" header="Title" v-bind:width="200")
    //- ================ menu of matrix =================
    ul.side_menu_group(v-if="$route.name == 'matrix' && !showLoading")
      //- // - var menus = ['mapping', 'preset', 'schedule', 'setting']
      - var menus = ['mapping', 'preset', 'setting']
      for menu in menus
        li.side__menu__single.clearfix
          a(
            @click="showLeft = false"
            v-link=" '#{ menu }' "
            v-bind:class="{'active': stateMatch('#{menu}')}") #{menu}
    ul.side_menu_group(v-if="$route.name == 'power' && !showLoading")
      - var menus = ['status', 'analysis', 'schedule', 'event', 'setting']
      for menu in menus
        li.side__menu__single.clearfix
          a(
            @click="showLeft = false"
            v-link=" '#{ menu }' "
            v-bind:class="{'active': stateMatch('#{menu}')}") #{menu}
    ul.side_meun_group(v-if="$route.name == 'mixer' && !showLoading")
      - var menus = ['status', 'layout', 'preset', 'setting']
      for menu in menus
        li.side__menu__single.clearfix
          a(
            @click="showLeft = false"
            v-link=" '#{ menu }' "
            v-bind:class="{'active': stateMatch('#{menu}')}") #{menu}
    ul.side_meun_group(v-if="$route.name == 'dio' && !showLoading")
      - var menus = ['status', 'schedule', 'event', 'setting', 'log']
      for menu in menus
        li.side__menu__single.clearfix
          a(
            @click="showLeft = false"
            v-link=" '#{ menu }' "
            v-bind:class="{'active': stateMatch('#{menu}')}") #{menu}
    ul.side_meun_group(v-if="$route.name == 'splitter' && !showLoading")
      - var menus = ['status', 'layout', 'setting', 'log']
      for menu in menus
        li.side__menu__single.clearfix
          a(
            @click="showLeft = false"
            v-link=" '#{ menu }' "
            v-bind:class="{'active': stateMatch('#{menu}')}") #{menu}
    ul.side_meun_group(v-if="$route.name == 'mes' && !showLoading")
      - var menus = ['port-status', 'setting']
      for menu in menus
        li.side__menu__single.clearfix
          a(
            @click="showLeft = false"
            v-link=" '#{ menu }' "
            v-bind:class="{'active': stateMatch('#{menu}')}") #{menu}
    //- online help menu group
    ul.side_menu_group.support_group(v-if="$route.name == 'matrix' && isInstaller && !showLoading")
      - var menus = ['HDCP', 'EDID', 'system', 'log']
      for menu in menus
        if menu !== 'HDCP'
          li.side__menu__single.clearfix
             a(
               @click="showLeft = false"
               v-link=" '#{ menu }' "
               v-bind:class="{'active': stateMatch('#{menu}')}") #{menu}
        else
           li.side__menu__single.clearfix
             a(
               @click="showLeft = false"
               v-link=" '#{ menu }' "
               v-bind:class="{'active': stateMatch('#{menu}')}") I/O Status
    ul.side_menu_group.support_group(v-if="$route.name == 'mixer' && isInstaller && !showLoading")
      - var menus = ['HDCP', 'EDID', 'system', 'log']
      for menu in menus
        if menu !== 'HDCP'
          li.side__menu__single.clearfix
             a(
               @click="showLeft = false"
               v-link=" '#{ menu }' "
               v-bind:class="{'active': stateMatch('#{menu}')}") #{menu}
        else
          li.side__menu__single.clearfix
             a(
               @click="showLeft = false"
               v-link=" '#{ menu }' "
               v-bind:class="{'active': stateMatch('#{menu}')}") I/O Status
    ul.side_menu_group.support_group(v-if="$route.name == 'power' && isInstaller && !showLoading")
      - var menus = ['system', 'log']
      for menu in menus
        li.side__menu__single.clearfix
           a(
             @click="showLeft = false"
             v-link=" '#{ menu }' "
             v-bind:class="{'active': stateMatch('#{menu}')}") #{menu}
    ul.side_menu_group(v-if="$route.name === 'nodev' && !showLoading")
      li.side__menu__single.clearfix
        a Please add new Device
    .outerLoadingBar(v-if="showLoading")
      .loadingBar
      span.loadingText Searching...
  #router-view-container
    router-view

</template>

<script>
  import { aside, alert } from 'vue-strap'
  import AppHeader from 'common/Header.vue'
  import { bindVM, getOnlineDevsRef } from './Service'
  import _ from 'lodash'
  import MobileDetect from 'mobile-detect'
  let md = new MobileDetect(window.navigator.userAgent)

  export default {
    components: {
      AppHeader,
      aside,
      alert
    },
    data () {
      return {
        showLoadingAni: false,
        showLeft: false,
        alertList: [],
        alertData: {
          type: '',
          title: '',
          show: false,
          content: ''
        },
        user: {},
        isInstaller: false,
        showWarning: false,
        alertDuration: 5000
      }
    },
    firebase () {
      return {
        onlines: {
          source: getOnlineDevsRef(),
          asObject: true
        }
      }
    },
    ready () {
      bindVM(this)
      console.log('App.vue ready')

      // show the warning and add the event listener
      if (window.innerWidth < 768 && md.mobile() === null) this.showWarning = true
      window.addEventListener('resize', this.resize)
      // this.showAlert()
      // setInterval(() => {  // make alerts wait in list
      //   if (this.alertList.length) {
      //     this.alertData = this.alertList.shift()
      //     this.alertData.show = false
      //     setTimeout(() => {
      //       this.alertData.show = true
      //     }, 100)
      //   }
      // }, 2500)
    },
    computed: {
      isCurrentOnline () {
        return this.onlines[this.$route.params.mac]
      },
      showLoading () {
        // current device is not online
        if (!this.isCurrentOnline) {
          this.loaderMsg = 'Current device is offline'
          this.loaderMsg1 = 'Please check the connection or try another device.'
        } else {
          this.loaderMsg = ''
        }
        return !(this.$route.noloading || this.isCurrentOnline)
      }
    },
    watch: {
      // alertData: {
      //   handler: function (n, o) {
      //     if (n > o) {
      //       console.log(n.content)
      //       this.alertData.show = true
      //       setTimeout(() => {
      //         this.alertData.show = false
      //       }, 4000)
      //     }
      //   },
      //   deep: true
      // }
    },
    methods: {
      // showAlert () {
      //   setInterval(() => {  // make alerts wait in list
      //     if (this.alertList.length) {
      //       this.alertData = this.alertList.shift()
      //       // watch the alertData for better performance
      //     }
      //   }, 3000)
      // },
      stateMatch (state) {
        return RegExp(`${state}$`).test(this.$route.path)
      },
      alert ({type, title, content}) {
        this.alertList.push({
          type,
          title,
          content,
          show: true
        })
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            this.alertList.shift()
            resolve()
          }, this.alertDuration)
        })
      },
      resize () {
        md = new MobileDetect(window.navigator.userAgent)
        if (window.innerWidth < 768 && md.mobile() === null) {
          this.showWarning = true
        } else {
          this.showWarning = false
        }
      }
    },
    events: {
      update (mac, {type, event, msg}) {
        if (mac === this.$route.params.mac) {
          this.alert({
            type: 'success',
            // title: 'Event ' + type,
            content: msg
          })
        }
        return true
      },
      user (uid, user) {
        if (this.user.name && this.user.name !== user.name) { // this.user initialized
          this.alert({
            type: 'success',
            titile: '',
            content: `Name Changes To '${user.name}'`
          })
        } else {
          this.user = _.cloneDeep(user)
        }
        // console.log('user is ', user)
        // console.log('uid  is ', uid)
        this.isInstaller = user.installer
        // this.$unbind('onlines')
        // this.$bindAsObject('onlines', getOnlineDevsRef(), null, () => console.log('vfire rebind since user auth changed!'))
        this.$broadcast('user', uid, user)
      },
      alert (e) {
        this.alert(e)
      },
      nav (obj) {
        this.showLeft = !this.showLeft
      }
    }
  }
</script>

<style lang="scss" rel="stylesheet/scss">
  // here injcet the bootstrap stylesheet
  @import "~bootstrap/dist/css/bootstrap.css";
  @import "~weather-icons/css/weather-icons.min.css";
  @import "~font-awesome/css/font-awesome.min.css";
  @import "./main.scss";
  .alert {
    z-index: $zindex_popover !important; // make over write the header
  }

  #router-view-container {
    padding-top: $Header_height;
  }

  // aside
  #side_menu{
    @include breakpoint(sm) {
      width:240px !important;
      min-width:240px !important;
    }
    @include breakpoint(xxs) {
      width:180px !important;
      min-width:180px !important;
    }
    background-color: $App_sidemenu_bg;
    padding-top:127px;
    @include App_sidemenu_mixin ();
    .side__menu__single{
      box-sizing:border-box;
      height:50px;
      a{
        padding:15px;
        margin-left: auto;
        margin-right: auto;
        width: 100%;
        display:block;
        text-decoration:none;
        color:$App_sidemenu_fg;
        font-size: 20px;
        line-height:20px;
        text-align:center;
        text-transform:capitalize;
        &.active,&:hover,&.offline{
          color: $App_sidemenu_item_active_fg;
          background-color: $App_sidemenu_item_active_bg;
        }
      }
    }
    .aside-header{
      display:none;
    }
    .aside-body {
      padding: 0;
    }

    .support_group{
      border-top:1px solid $base_gray;
      padding-top: $space_sm;
      display:block;
    }
  }
  // alert style
  .alert.top-right {
    position: fixed;
    top: 30px;
    right: 50px;
    z-index: 2;
    @include breakpoint(xxs){
      right: 0px !important;
      left: 0px;
      margin: auto;
    }
  }

/* ======== aside loading animation =============== */

.outerLoadingBar{
  width: 100%;
  height: 300px;
  position: absolute;
  top: 0;
  left: 0;
}
.loadingBar {
  position: absolute;
  top: 50%;
  @include breakpoint(iFive){
    top:36%;
  }
  left: 46%;
  height: 25px;
  width: 10px;
  border-radius: 10%;
  background: $App_sidemenu_loading_light;
  border-top-color: $App_sidemenu_loading_dim;
  animation: fade2 1s infinite;
  transition: background .2s;
  &:after, &:before {
    content: '';
    position: absolute;
    display: block;
    height: 20px;
    width: 10px;
    background: $App_sidemenu_loading_light;
    top: 50%;
    transform: translateY(-50);
    left: -15px;
    border-radius: 10%;
    animation: fade1 1s infinite;
    transition: background .2s;
  }
  &:before { left: 15px; animation: fade3 1s infinite; }
}
.loadingText{
  position: absolute;
  top: 42%;
  left: 46%;
  transform:translateY(200%) translateX(-35%);
  animation: blink 1s infinite;
  font-size: 22px;
  opacity:.5;
  color: $App_sidemenu_fg;
  @include breakpoint(iFive){
    font-size: 18px;
    top:32%;
  }
}

@keyframes fade1 {  0% { background:  $App_sidemenu_loading_dim; } }
@keyframes fade2 {  33% { background: $App_sidemenu_loading_dim; } }
@keyframes fade3 {  66% { background: $App_sidemenu_loading_dim; } }
@keyframes blink {
  0%  { opacity: .5;}
  33% { opacity: 1; }
}

/* ======== center loading animation ============== */
@mixin poa ($top ,$right ,$bottom ,$left ){
  position: absolute;
  top: $top;
  right: $right;
  bottom: $bottom;
  left: $left;
}
@mixin size($width,$height:$width){
  width:$width;
  height:$height;
}
@mixin ani($animation...){
  -o-animation:$animation;
  -ms-animation:$animation;
  -moz-animation:$animation;
  -webkit-animation:$animation;
}
.loaderBackDrop{
  position: fixed;
  margin-top: -10px;
  width: 100%;
  height: 100%;
  background-color: $App_loading_bg;
  z-index: 100;
  .loader {
    width: 300px;
    height: 80px;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    color:$App_loading_title_text_fg;
    text-align:center;
    .loadStyle{
      @include size(50px);
      display:inline-block;
      vertical-align:middle;
      position: relative;
      margin-right: 10px;
      @include poa(0px,0px,0px,0px);
    }
    .loadTextDetail{
      font-size: 20px;
      color: $App_loading_detail_text_fg;
      @include breakpoint(sm){
        font-size: 18px;
      }
      @include breakpoint(xxs){
        font-size: 14px;
      }
    }
    .loadText{
      font-size: 50px;
      @include breakpoint(xxs) {
        font-size: 40px;
        margin-left: 40px;
      }
      @include breakpoint(iFive){
        font-size: 26px;
      }
      line-height: 50px;
      margin-left: 55px;
    }
    .load2{
      border-radius:50px;
      border:5px solid transparent;
      border-top-color: $App_loading_spin_fg;
      border-bottom-color: $App_loading_spin_fg;
      @include breakpoint(sm){
        margin-top: 5px;
      }
      @include breakpoint(xxs){
        margin-left: 10px;
      }
      @include breakpoint(iFive){
        margin-left: 40px;
      }
      @include ani(spin 1.5s linear infinite);
      &:after,&:before{
        content:'';
        border-radius:50px;
        border:5px solid transparent;
        border-top-color:$App_loading_spin_fg;
        border-bottom-color:$App_loading_spin_fg;
        @include poa(5px,0px,0px,5px);
        @include size(30px);
        @include ani(spinreverse 2s linear infinite);
        opacity:.4;
      }
    }
  }// close loader
}// close loader backdrop

.loaderBackDrop.warning{
  background-color:black;
  .text {
    font-size: 2.2em;
  }
  .loader{
    top: -200px;
    width:90%;
    max-width:500px;
  }

}
// to hide the fking About ZingChart
#inputVoltage-menu-item-xmiabt,
#bankCurrent-menu-item-xmiabt,
#bankPower-menu-item-xmiabt {
  display: none !important;
}


.alert {
  margin-bottom: 5px !important;
}

.alert_group {
  position: fixed;
  top: 30px;
  right: 50px;
  z-index: 2050;
}
.alert__single {
  position: relative;
}

</style>



// WEBPACK FOOTER //
// App.vue?19f2e62a